import Modal from "components/Modal";
import { useToastStore } from "components/Toast/toastStore";
import { useRouter } from "next/router";
import { useIsDesktop } from "lib/device";
import { IconSocial } from "components/Icon/IconSocial";
import Button from "components/Button";
import { isMoodleURL } from "lib/host";

interface IData {
  id?: string;
  href?: string;
  label?: string;
  slug?: string;
}

export const ModalShare: React.FC<{
  isShow?: boolean;
  onClose?(): void;
  title?: string;
  data?: IData[];
  useModal?: boolean;
  isSubdomain?: boolean;
  isB2B?: boolean;
  isMoodle?: boolean;
  originalURL: string;
  onClickShare?: (d: IData) => void;
  className?: string;
}> = ({
  isShow,
  onClose,
  title,
  data,
  onClickShare,
  useModal = true,
  isSubdomain = false,
  isB2B = false,
  isMoodle = false,
  originalURL = "",
  className = "",
}) => {
  const router = useRouter();
  const showToast = useToastStore((state) => state.showToast);

  const onCopyLink = () => {
    let temp = document.createElement("textarea");
    let url = window.location.href;
    temp.value = url;
    temp.id = "url-input";

    document.body.appendChild(temp);
    temp.select();
    document.execCommand("copy");
    temp.remove();

    onClose();

    showToast({
      type: "success",
      message: "Link berhasil disalin!",
    });
  };

  const onPushRoute = (link) => {
    onClose();
  };

  const isDesktop = useIsDesktop();

  const renderContent = (theme = "grid grid-cols-3 ") => {
    if (isB2B || isMoodle) {
      const subdomainLink = data.length > 0 && data[4];
      const moodleLink = data.length > 0 && data[5];
      let inputValue = !isSubdomain ? moodleLink.href : subdomainLink.href;

      const originalURL = document.referrer;

      if (originalURL.includes("plus")) {
        inputValue = `https://gok-ares-enterprise-plus.learnext.ai/iframe?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("megainsurance")) {
        inputValue = `https://apps.megainsurance.co.id:8803/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("bogalearning")) {
        inputValue = `http://bogalearning.com/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("bersatulearning")) {
        inputValue = `https://bersatulearning.com/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("wlc")) {
        inputValue = `https://wlc.kemenparekraf.go.id/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("esdm")) {
        inputValue = `https://smile.esdm.go.id/lms/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("kemkes")) {
        inputValue = `https://kms.kemkes.go.id/gokampus?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("pupuk-indonesia")) {
        inputValue = `https://lms-dev.pupuk-indonesia.com/gokampus-library?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("sippa")) {
        inputValue = `https://sippa.kemenperin.go.id/jf/microlearning/ml/peserta?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("sijule")) {
        inputValue = `https://sijule-bpsdm.jakarta.go.id/?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("bps")) {
        inputValue = `https://lms.bps.go.id/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("ioh")) {
        inputValue = `https://ide.ioh.co.id/academy/course?type=course&slug=${subdomainLink.slug}`;
      }

      if (originalURL.includes("gaji")) {
        inputValue = `https://member.gaji.id/gaji/#/fitur-extra/edukasi/go-kampus?type=course&slug=${subdomainLink.slug}`;
      }

      const unsecuredCopyToClipboard = (text) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
        } catch (err) {
          console.error("Unable to copy to clipboard", err);
        }
        document.body.removeChild(textArea);
      };

      return (
        <div className="h-36 flex">
          <input
            type="text"
            className="border border-neutral-40 rounded-8 h-full flex-1 px-12 mr-8"
            value={inputValue}
            disabled
          />

          <Button
            onClick={() => {
              if (!navigator.clipboard) {
                unsecuredCopyToClipboard(inputValue);
              } else {
                navigator.clipboard.writeText(inputValue);
              }

              onClose();

              showToast({
                type: "success",
                message: "Link berhasil disalin!",
              });

              if (onClickShare) {
                onClickShare({ id: "Copy Link" });
              }
            }}
          >
            Salin Link
          </Button>
        </div>
      );
    }

    return (
      <div className={theme || ""}>
        {data &&
          data.length > 0 &&
          data.map((el) => (
            <a
              target="_blank"
              key={el.id + "Shared"}
              href={el.href && el.id !== "link" ? el.href : undefined}
              onClick={() => {
                if (onClickShare) {
                  onClickShare(el);
                }
                el.href && el.id !== "link"
                  ? onPushRoute(el.href)
                  : onCopyLink();
              }}
              className="cursor-pointer flex justify-center"
              rel="noopener noreferrer"
            >
              {
                {
                  whatsapp: (
                    <div className="flex flex-col items-center">
                      <IconSocial icon="wa" />
                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                  instagram: (
                    <div className="flex flex-col items-center">
                      <IconSocial />

                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                  twitter: (
                    <div className="flex flex-col items-center">
                      <IconSocial icon="twitter" />

                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                  linkedin: (
                    <div className="flex flex-col items-center">
                      <IconSocial icon="linkedin" />

                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                  facebook: (
                    <div className="flex flex-col items-center">
                      <IconSocial icon="fb" />

                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                  link: (
                    <div className="flex flex-col items-center">
                      <IconSocial icon="link" />

                      {useModal && (
                        <p className="text-b2 text-neutral-70">{el.label}</p>
                      )}
                    </div>
                  ),
                }[el.id]
              }
            </a>
          ))}
      </div>
    );
  };

  if (useModal) {
    return (
      <Modal color="#000" title={title} isShow={isShow} onClose={onClose}>
        {renderContent("my-16 gap-10 flex justify-between")}
      </Modal>
    );
  } else {
    return (
      <div
        className={`flex flex-row gap-20 items-center justify-end ${className}`}
      >
        <div className="text-b2 font-medium text-neutral-60">Bagikan : </div>
        {renderContent("flex flex-row justify-end gap-12")}
      </div>
    );
  }
};
